import { render, staticRenderFns } from "./UploaderSection.vue?vue&type=template&id=553c9b6a"
import script from "./UploaderSection.vue?vue&type=script&lang=js"
export * from "./UploaderSection.vue?vue&type=script&lang=js"
import style0 from "./UploaderSection.vue?vue&type=style&index=0&id=553c9b6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports